import {
  Avatar,
  Step,
  StepConnector,
  stepConnectorClasses,
  StepLabel,
  Stepper,
  styled,
} from '@mui/material';
import { ICustomStepperIcon } from 'Components';
import { useIsDesktop } from 'Hooks';
import {
  LightUncheckedIcon,
  PurpleAlert,
  PurpleCheckMark,
  RequestsStepperActive,
} from 'Images';
import { ReactElement, useEffect } from 'react';

interface IFormStepper {
  steps: { name: string; endDate?: string }[];
  lastStepIndex?: number;
  activeStepIndex: number;
  setActiveStepIndex?: (index: number) => void;
  isDenied?: boolean;
  slideContent?: ReactElement;
}

const CustomStepMobile = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#A020FF',
      minHeight: '40px',
    },
  },
  [`&.${stepConnectorClasses.disabled}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      minHeight: '40px',
    },
  },
}));

const CustomStepDesktop = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.disabled}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#E4C1FF',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#A020FF',
    },
  },
}));

const CustomConnector = () => {
  const isDesktop = useIsDesktop();
  return isDesktop ? <CustomStepDesktop /> : <CustomStepMobile />;
};

const CustomStepperIcon = ({
  active,
  completed,
  isLastStep,
  isDenied,
}: ICustomStepperIcon) => {
  let avatarSrc = () => {
    if (isLastStep) return isDenied ? PurpleAlert : RequestsStepperActive;
    if (active) return RequestsStepperActive;
    if (completed) return PurpleCheckMark;
    return LightUncheckedIcon;
  };

  return (
    <Avatar
      src={avatarSrc()}
      alt=''
      sx={{
        width: '24px',
        height: '24px',
      }}
    />
  );
};

export const FormStepper = ({
  steps,
  activeStepIndex,
  lastStepIndex = activeStepIndex,
  setActiveStepIndex = (number: number) => {},
  isDenied = false,
  slideContent,
}: IFormStepper) => {
  const isDesktop = useIsDesktop();

  useEffect(() => {
    setActiveStepIndex(lastStepIndex);
  }, [lastStepIndex, setActiveStepIndex]);

  return (
    <Stepper
      alternativeLabel
      connector={<CustomConnector />}
      sx={{
        backgroundColor: isDesktop ? 'primary.shade_50' : '#fff',
        borderRadius: '12px',
        padding: '10px 20px',
      }}
    >
      {steps.map((step, index) => (
        <Step
          key={index}
          completed={index <= lastStepIndex}
          sx={{
            flex: '1 1 0',
            width: '0',
          }}
          active={index === activeStepIndex}
        >
          <StepLabel
            StepIconComponent={CustomStepperIcon}
            role='radio'
            onClick={
              index <= lastStepIndex
                ? () => setActiveStepIndex(index)
                : undefined
            }
            onKeyDown={
              index <= lastStepIndex
                ? (e) => {
                    if (e.key === 'Enter') setActiveStepIndex(index);
                  }
                : undefined
            }
            sx={{
              cursor: index <= lastStepIndex ? 'pointer !important' : undefined,
            }}
          />
        </Step>
      ))}
    </Stepper>
  );
};
